import styled from "styled-components";
import { Tabs as ANTDTabs} from "antd";

export const Tabs = styled(ANTDTabs)`
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #6c7485;
    }

    .ant-tabs-tab {
        color: #6c7485;
    }

    .ant-tabs-tab:hover {
        color: rgba(0, 0, 0, 0.85);
    }

    .ant-tabs-ink-bar {
        background: #000;
    }

    .ant-tabs-tab-btn:focus, .ant-tabs-tab-remove:focus, .ant-tabs-tab-btn:active, .ant-tabs-tab-remove:active {
        color: #6c7485;
    }
    
    .ant-tabs-nav::before {
        position: inherit
    }
`;